import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '~/shared/utils/date.utils';

@Pipe({
  name: 'localDate',
  standalone: true
})
export class LocalDatePipe implements PipeTransform {
  transform(value: Date | string, customFormat?: CustomFormat): string {
    if (!value) {
      return '';
    }

    let formattedDate: string;

    switch (customFormat) {
      case 'MONTH-YEAR':
        formattedDate = DateUtils.format('MMMM YYYY', value);
        break;
      case 'TIME':
        formattedDate = DateUtils.format('HH:mm', value);
        break;
      default:
        formattedDate = DateUtils.format('DD.MM.YYYY', value);
        break;
    }

    return formattedDate;
  }
}

type CustomFormat = 'MONTH-YEAR' | 'TIME';
